
import React from 'react';
import { Studio } from '@/hooks/use-studios';
import { Badge } from '@/components/ui/badge';
import { motion } from 'framer-motion';
import { Clock, MapPin, Star, Info, Phone } from 'lucide-react';

interface StudioHeaderProps {
  studio: Studio;
}

export const StudioHeader: React.FC<StudioHeaderProps> = ({ studio }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="relative"
    >
      <div className="flex flex-col md:flex-row md:items-center gap-6">
        {/* Logo placeholder */}
        <div className="flex-shrink-0 w-24 h-24 md:w-32 md:h-32 bg-zinc-800 rounded-xl flex items-center justify-center border border-zinc-700">
          <span className="text-3xl font-bold text-zinc-400">
            {studio.name.charAt(0)}
          </span>
        </div>
        
        <div className="flex flex-col gap-2">
          <h1 className="text-3xl md:text-4xl font-bold tracking-tight">{studio.name}</h1>
          
          <div className="flex flex-wrap gap-2 items-center text-sm text-zinc-400">
            {studio.is_registered && (
              <Badge variant="outline" className="bg-[#2C6E49]/10 text-[#2C6E49] border-[#2C6E49]/20">
                Verifiziert
              </Badge>
            )}
            
            {studio.address && (
              <div className="flex items-center gap-1">
                <MapPin size={14} />
                <span>{studio.address}</span>
              </div>
            )}
            
            {studio.phone && (
              <div className="flex items-center gap-1">
                <Phone size={14} />
                <span>{studio.phone}</span>
              </div>
            )}
            
            {/* Opening hours */}
            <div className="flex items-center gap-1">
              <Clock size={14} />
              <span>Heute geöffnet: 9:00 - 18:00</span>
            </div>
            
            {/* Rating */}
            <div className="flex items-center gap-1">
              <Star size={14} className="fill-amber-400 text-amber-400" />
              <span className="text-white">{studio.rating_avg?.toFixed(1) || '0.0'}</span>
              <span className="text-zinc-400">({studio.rating_count || 0})</span>
            </div>
          </div>
          
          <p className="text-zinc-300 text-sm md:text-base mt-2 max-w-2xl">
            {studio.description || 'Keine Beschreibung vorhanden.'}
          </p>
        </div>
      </div>
    </motion.div>
  );
};
